import React, { useState, useEffect } from 'react';
import { TrendingUp, MessageSquare, Heart, ChevronRight } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { getTrendingPosts, Post } from '@/db/api';
import { formatDistanceToNow } from 'date-fns';
import { zhCN } from 'date-fns/locale';

const TrendingSidebar: React.FC = () => {
  const [posts, setPosts] = useState<Post[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTrending = async () => {
      try {
        const data = await getTrendingPosts();
        setPosts(data);
      } catch (err) {
        console.error('Fetch trending error:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchTrending();
  }, []);

  if (loading) return (
    <div className="space-y-4 animate-pulse">
      {[1, 2, 3].map(i => (
        <div key={i} className="h-20 bg-muted rounded-xl"></div>
      ))}
    </div>
  );

  return (
    <Card className="rounded-xl overflow-hidden glass-card border-border/50 sticky top-24">
      <CardHeader className="p-4 pb-2 border-b border-border/50 bg-primary/5">
        <CardTitle className="text-lg flex items-center gap-2 text-primary font-bold">
          <TrendingUp className="h-5 w-5" />
          本周热门榜
        </CardTitle>
      </CardHeader>
      <CardContent className="p-4 pt-4 space-y-6">
        {posts.length > 0 ? (
          posts.map((post, index) => (
            <div key={post.id} className="flex gap-4 group cursor-pointer border-b border-border/30 pb-4 last:border-0 last:pb-0">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center text-primary font-bold text-sm">
                {index + 1}
              </div>
              <div className="flex-1 space-y-1">
                <h4 className="text-sm font-bold line-clamp-2 group-hover:text-primary transition-colors leading-relaxed">
                  {post.title}
                </h4>
                <div className="flex items-center gap-3 text-[10px] text-muted-foreground">
                  <span className="flex items-center gap-1 font-medium">
                    <Heart className="h-3 w-3" /> {post.likes_count}
                  </span>
                  <span className="flex items-center gap-1 font-medium">
                    <MessageSquare className="h-3 w-3" /> {post.comments_count}
                  </span>
                  <span>{formatDistanceToNow(new Date(post.created_at), { locale: zhCN })}</span>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="text-center py-10 text-muted-foreground text-sm">
            暂无热门内容
          </div>
        )}
        
        <Button 
          variant="ghost" 
          className="w-full text-primary hover:bg-primary/5 h-10 gap-2 font-bold rounded-lg border border-primary/20"
          onClick={() => {}}
        >
          查看完整榜单
          <ChevronRight className="h-4 w-4" />
        </Button>
      </CardContent>
    </Card>
  );
};

export default TrendingSidebar;
已